module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CF - Central African Republic.14ada5f4.svg";